import { ViewProps } from 'react-native'
import type { FileUploadStatusEnum } from 'APP/Store/History/types'

export type BaseFile = {
  uri: string
  name: string
  size: number
}

export enum FileTypes {
  IMAGE = 'image',
  PDF = 'pdf',
}

export type ImageFile = BaseFile & {
  type: FileTypes.IMAGE
  alt?: string
}

export type PDFFile = BaseFile & {
  type: FileTypes.PDF
}

export type SupportedFile = ImageFile | PDFFile

export type SupportedFileWithMetadata = SupportedFile & {
  fileType?: string
  fileId?: string
  uploadStatus?: FileUploadStatusEnum
  uploadError?: string | null
}

export type PreviewSize = { width: number }

export type FilePreviewProps = {
  isLoading?: boolean
  file: SupportedFileWithMetadata | null
  size?: PreviewSize
  showMetadata?: boolean
  aspectRatio?: number
  onClick?: (file: SupportedFileWithMetadata) => void
  onDelete?: (file: SupportedFileWithMetadata) => void
  testID?: string
  renderActions?: (file: SupportedFileWithMetadata) => React.ReactNode
  renderMetadata?: (file: SupportedFileWithMetadata) => React.ReactNode
  renderPreview?: (file: SupportedFileWithMetadata) => React.ReactNode
  style?: ViewProps['style']
}

export type ContentContainerProps = Pick<FilePreviewProps, 'size' | 'testID'>
